export const SPLIT_IO_FEATURES = {
  ENABLE_USER_CONSENT: 'cinnamon-enable-user-consent',
}
Object.freeze(SPLIT_IO_FEATURES)
export const SPLIT_NAMES = [SPLIT_IO_FEATURES.ENABLE_USER_CONSENT]
